import LandingCTA from './LandingCTA'
import LandingFAQ from './LandingFAQ'
import LandingFooter from './LandingFooter'
import LandingFounder from './LandingFounder'
import LandingGrowth from './LandingGrowth'
import LandingHeader from './LandingHeader'
import LandingHero from './LandingHero'
import LandingHowItWorks from './LandingHowItWorks'
import LandingPains from './LandingPains'
import LandingPricingTeaser from './LandingPricingTeaser'
import LandingProductTour from './LandingProductTour'
import LandingProofBar from './LandingProofBar'
import LandingSwitch from './LandingSwitch'
import LandingWhy from './LandingWhy'

export default function Landing() {
  return (
    <div className="bg-white">
      <LandingHeader />
      <main>
        <LandingHero />
        <LandingProofBar />
        <LandingPains />
        <LandingHowItWorks />
        <LandingProductTour />
        <LandingGrowth />
        <LandingWhy />
        <LandingSwitch />
        <LandingFounder />
        <LandingPricingTeaser />
        <LandingFAQ />
        <LandingCTA />
      </main>
      <LandingFooter />
    </div>
  )
}
